import { api } from "./client";
import type { components } from "./contract";
import { unwrap } from "./errors";

/**
 * MCP connector types + the one read shared across features (chat's composer
 * picker and settings' management page both list the user's connectors). Lives
 * in `api/` — like `transcribeAudio` — because features must not import
 * sideways; settings-only mutations stay in `features/settings/api`.
 */
export type UserConnector = components["schemas"]["MCPConnector"];
export type ConnectorCatalogEntry = components["schemas"]["MCPCatalogEntry"];

export async function listMyConnectors(): Promise<UserConnector[]> {
  const result = unwrap(await api.GET("/v1/me/connectors"));
  return result.connectors;
}
